import { Badge } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SBadge = styled(Badge)``;
